@let image = getSignal('image')();
@let button = getSignal('button')();
<div class="content-container">
    @if(image.success) {
        <app-editable-image 
            [elemId]="image.payload" 
            [imageReference]="imageReference"
            [fileTypes]="supportedFileTypes"
            [maxWidth]="1920"
            [maxHeight]="1080"
            [customClass]="'single-column-text-image-custom-class-image custom-elevation-z2'">
        </app-editable-image>
    }

    @if(button.success) {
        <div class="button-overlay">
            <app-editable-button 
                [elemId]="button.payload"
                [customClass]="'base-card-custom-class-button'">
            </app-editable-button>
        </div>
    }
</div>